export const ROLES = {
  admin: 'admin',
  campaign_manager: 'campaign-manager',
  campaign_view: 'campaign-view',
  user: 'user',
  read_only: 'read-only',
  visitor: 'visitor'
}
